import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "searchInput", "list", "item", "emptyState"]

  connect() {
    this.activeIndex = -1
    this.applyFilter("")
  }

  open(event) {
    event?.preventDefault()
    if (!this.hasModalTarget) return

    if (typeof this.modalTarget.showModal === "function") {
      this.modalTarget.showModal()
    } else {
      this.modalTarget.style.display = "block"
      this.modalTarget.setAttribute("open", "open")
    }

    this.focusSearchInput()
  }

  close(event) {
    event?.preventDefault()
    if (!this.hasModalTarget) return

    if (typeof this.modalTarget.close === "function") {
      this.modalTarget.close()
    } else {
      this.modalTarget.style.display = "none"
      this.modalTarget.removeAttribute("open")
    }

    this.reset()
  }

  filter(event) {
    this.applyFilter(event.target.value)
  }

  handleKeydown(event) {
    const visibleItems = this.visibleItems()
    if (visibleItems.length === 0) return

    if (event.key === "ArrowDown") {
      event.preventDefault()
      this.moveActive(1)
      return
    }

    if (event.key === "ArrowUp") {
      event.preventDefault()
      this.moveActive(-1)
      return
    }

    if (event.key === "Enter") {
      event.preventDefault()
      if (this.activeIndex < 0) this.activeIndex = 0
      visibleItems[this.activeIndex]?.click()
    }
  }

  reset() {
    this.activeIndex = -1
    if (this.hasSearchInputTarget) {
      this.searchInputTarget.value = ""
    }
    this.applyFilter("")
  }

  applyFilter(query) {
    const normalizedQuery = query.trim().toLowerCase()
    let visibleItems = 0

    this.itemTargets.forEach((item) => {
      const name = (item.dataset.searchName || item.textContent || "").toLowerCase()
      const isVisible = name.includes(normalizedQuery)
      item.classList.toggle("hidden", !isVisible)
      item.classList.remove("bg-base-300/40")
      if (isVisible) visibleItems += 1
    })

    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.toggle("hidden", visibleItems > 0)
    }

    this.activeIndex = visibleItems > 0 ? 0 : -1
    this.highlightActive()
  }

  moveActive(step) {
    const visibleItems = this.visibleItems()
    if (visibleItems.length === 0) return

    if (this.activeIndex < 0) {
      this.activeIndex = 0
    } else {
      this.activeIndex = (this.activeIndex + step + visibleItems.length) % visibleItems.length
    }

    this.highlightActive()
  }

  highlightActive() {
    const visibleItems = this.visibleItems()
    visibleItems.forEach((item, index) => {
      const isActive = index === this.activeIndex
      item.classList.toggle("bg-base-300/40", isActive)
      if (isActive) {
        item.scrollIntoView({ block: "nearest" })
      }
    })
  }

  visibleItems() {
    return this.itemTargets.filter((item) => !item.classList.contains("hidden"))
  }

  focusSearchInput() {
    if (!this.hasSearchInputTarget) return

    const focus = () => {
      this.searchInputTarget.focus({ preventScroll: true })
      this.searchInputTarget.select()
    }

    requestAnimationFrame(focus)
    setTimeout(focus, 0)
    setTimeout(focus, 80)
  }
}
